// apps/frontend/src/utils/cloudinaryBlur.ts
// Helper Cloudinary : génère l'URL d'une version tiny+floutée d'une image
// (≈1-2 ko) pour servir de placeholder pendant le chargement de la vraie.
// Retourne null si l'URL n'est pas Cloudinary.

const CLOUDINARY_BLUR_PARAMS = 'w_24,e_blur:1000,q_auto,f_auto';

export function getCloudinaryBlurUrl(
  src: string | null | undefined
): string | null {
  if (!src) return null;
  const m = src.match(
    /^(https:\/\/res\.cloudinary\.com\/[^/]+\/image\/upload\/)(.+)$/
  );
  if (!m) return null;
  const [, base, rest] = m;
  return `${base}${CLOUDINARY_BLUR_PARAMS}/${rest}`;
}
